import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

export interface EBooks {
  auth_key: string;
  data: [
    {
      id: number;
      id_user: number;
      id_book: string;
      file: string;
      page: number;
      fechaini: number;
      fechafin: number;
    }
  ];
}
export interface Compras {
  auth_key: string;
  data: [
    {
      id: number;
      id_user: number;
      nombre: string;
      e_name: string;
      identificacion: string;
      correo: string;
      telefono: string;
      fecha_compra: string;
      x_fecha_transaccion: string;
      ciudad: string;
      direccion: string;
      test: number;
      id_factura: string;
      estado: string;
      detalles: [
        {
          id: number;
          id_compra: number;
          id_producto: number;
          precio_producto: string;
          precio_pagado: string;
          total: string;
          impuesto_valor: string;
          impuesto_id: string;
          descuento: string;
          qty: number;
          costo_fijo_variable: string;
          costo_envio: string;
          costo_envio_total: string;
          fisicodigital: number;
          nombre_archivo: string;
          formato_ebook: string;
          ebook: {
            id: number;
            autor: string;
            coleccion: string;
            combo: string;
            titulo: string;
            edicion: string;
            ano_edicion: string;
            idioma: string;
            formato: string;
            isbn: string;
            descripcion: string;
            ilustrador: string;
            editorial: string;
            id_categoria: string;
            cantidad: string;
            precio: string;
            precio2: string;
            descuento: string;
            tipo_formato: string;
            anchura: string;
            altura: string;
            profundidad: string;
            peso: string;
            costo_envio: string;
            imagen: string;
            costo_manual: string;
            tematica: string;
            calificacion: string;
            encuadernacion: string;
            no_paginas: string;
            edad: string;
            edad_max: string;
            nivel: string;
            fisicodigital: string;
            estado: string;
            nombre_archivo: string;
            formato_ebook: string;
          };
        }
      ];
    }
  ];
}

@Injectable({
  providedIn: "root",
})
export class EbooksService {
  constructor(private http: HttpClient) {}

  getCompras(id, auth_key) {
    let postData = [];
    postData.push({ auth_key: auth_key });
    postData.push({ id: id });
    postData.push({ data: [] });
    return this.http.post<Compras>(
      environment.urlCompra + "/apicompra?opcion=2",
      JSON.stringify(postData)
    );
    /********************** */
  }

  getEbook(id, auth_key, data) {
    let postData = [];
    postData.push({ auth_key: auth_key });
    postData.push({ id: id });
    postData.push({ data: data });
    return this.http.post(
      environment.urlCompra + "/apicompra?opcion=3",
      JSON.stringify(postData),
      { responseType: "blob" }
    );
    /********************** */
  }
  getEbookV2(id, token) {
    let hdrs = new HttpHeaders();
    hdrs = hdrs.set("Authorization", `Bearer ${token}`);
    //{responseType: 'blob',headers : hdrs}
    return this.http.get(`${environment.urlEpub}?id=${id}`, {
      responseType: "blob",
    });
    /********************** */
  }
  getListBooks(dataFilter: any, page = 1, pageSize = 24) {
    console.log("🚀 ~ EbooksService ~ getListBooks ~ dataFilter:", dataFilter);
    let params = new HttpParams()
      .set("page", page.toString())
      .set("pageSize", pageSize.toString());

    // Agregar valores simples
    if (dataFilter.name) params = params.set("name", dataFilter.name);
    if (dataFilter.e1) params = params.set("edadMin", dataFilter.e1);
    if (dataFilter.e2) params = params.set("edadMax", dataFilter.e2);
    if (dataFilter.orden) params = params.set("orden", dataFilter.orden);

    // Agregar arrays como collection[]=2&collection[]=3
    if (Array.isArray(dataFilter.coleccion)) {
      dataFilter.coleccion.forEach((val: any) => {
        params = params.append("collection[]", val);
      });
    }

    if (Array.isArray(dataFilter.autor)) {
      dataFilter.autor.forEach((val: any) => {
        params = params.append("autor[]", val);
      });
    }

    return this.http.get(`${environment.urlListBooks}`, {
      params,
      responseType: "json",
    });
  }

  getBookById(id) {
    //{responseType: 'blob',headers : hdrs}
    return this.http.get(`${environment.urlGetBookById}?id=${id}`, {
      responseType: "json",
    });
    /********************** */
  }
  getUrl(id, auth_key, url) {
    let postData = [];
    postData.push({ auth_key: auth_key });
    postData.push({ id: id });
    postData.push({ data: url });
    return this.http.post<any>(
      environment.urlCompra + "/apicompra?opcion=4",
      JSON.stringify(postData)
    );
    /********************** */
  }

  listAudioBook(auth_key, id_user, id_libro) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id_user);
    formData.append("id_libro", id_libro);

    return this.http.post<any>(
      environment.urlProductosAudio + "/api-index-admin",
      formData,
      options
    );
    /********************** */
  }

  getCurrent(auth_key, id_user, id_libro, id_audio, currentime) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id_user);
    formData.append("ProductosAudiosCurrentime[id_productos_audio]", id_audio);
    formData.append("ProductosAudiosCurrentime[id_user]", id_user);
    formData.append("ProductosAudiosCurrentime[currentime]", currentime);

    console.log("auth_key", auth_key);
    console.log("formData", formData);

    return this.http.post<any>(
      environment.urlProductosAudio + "/api-currentime",
      formData,
      options
    );
  }
}
